import { useState, useEffect } from "react"
import { doc, onSnapshot } from "firebase/firestore"
import { firestore } from "../firebase"

export const useUserBalance = (userId) => {
  const [balance, setBalance] = useState(0)

  useEffect(() => {
    if (!userId) {
      setBalance(0)
      return
    }

    const userDocRef = doc(firestore, "users", userId)

    const unsubscribe = onSnapshot(
      userDocRef,
      (doc) => {
        if (doc.exists()) {
          const userData = doc.data()
          setBalance(userData.balance || 0)
        } else {
          console.log("No such user document!")
          setBalance(0)
        }
      },
      (error) => {
        console.error("Error fetching user balance:", error)
        setBalance(0)
      }
    )

    return () => unsubscribe()
  }, [userId])

  return balance
} 